// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"261":"80b66860","876":"91621c64"}[chunkId] + ".chunk.css";
};